import {Mapper} from '@s-ui/domain'

export class HttpRelatedSubscriptionAdsResponseToSubscriptionAdsListValueObjectMapper extends Mapper {
  constructor({config, subscriptionAdEntityFactory, subscriptionAdsListValueObjectFactory}) {
    super()
    this._config = config
    this._subscriptionAdEntityFactory = subscriptionAdEntityFactory
    this._subscriptionAdsListValueObjectFactory = subscriptionAdsListValueObjectFactory
    this._defaultSegment = this._config.get('subscription').DEFAULT_SEGMENT
    this._modelIdMapping = this._config.get('subscription').modelIdMapping
    this._fallbackAds = this._config.get('subscription').FALLBACK_ADS
  }

  setParams = ({count, modelId} = {}) => {
    this._count = count
    this._modelId = modelId
    return this
  }

  map = rawSubscriptionAds => {
    const mappedSegment = this._modelIdMapping[this._modelId]

    if (mappedSegment) {
      const subscriptionAds = rawSubscriptionAds
        .map(
          ({
            description,
            id,
            imageUrl: imgUrl,
            brand: make,
            model,
            monthlyFee: minimumMonthlyFee,
            segment,
            linkUrl: url,
            version
          }) => {
            return this._subscriptionAdEntityFactory({
              description,
              id,
              imgUrl,
              make,
              model,
              minimumMonthlyFee,
              segment,
              title: `${make} ${model} ${version}`,
              url,
              version
            })
          }
        )
        .filter(ad => ad.getSegment() === mappedSegment)
        .slice(0, this._count)
      return this._subscriptionAdsListValueObjectFactory({
        items: [...subscriptionAds]
      })
    }

    const subscriptionAdsFallbackVOs = this._fallbackAds
      .map(ad => {
        return this._subscriptionAdEntityFactory(ad)
      })
      .slice(0, this._count)

    return this._subscriptionAdsListValueObjectFactory({
      items: [...subscriptionAdsFallbackVOs]
    })
  }
}
